module.exports = __webpack_public_path__ + "static/media/FreelancerAvatar.20481b4314dcfe785996c543506b8c82.svg";